import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import DemandeStatusEnum, {
	type DemandeStatusType,
} from '../enums/demandeStatusEnum';
import type { DemandeCompte } from '../interfaces/demandeCompte';
import type { UtilisateurCollectivite } from '../interfaces/utilisateurCollectivite';

export interface StatistiquesDemandeCompte {
	total: number;
	ok: number;
	hs: number;
	encours: number;
	traitee: number;
	abandon: number;
	nontraitee: number;
	autre: number;
}

interface PostPastellUserResult {
	demande_compte: DemandeCompte;
	utilisateurASupprimer: UtilisateurCollectivite;
	status: string;
}

export const getDemandesComptes = async () =>
	request.get<unknown, TemplateRequestGet<DemandeCompte>>(
		'/api/ixchange/demandeCompte?all=true',
	);

export const getStatistiquesDemandeCompte = async (codeClient?: string) =>
	request.get<unknown, StatistiquesDemandeCompte>(
		'/api/ixchange/demandeCompte/statistiques',
		codeClient ? { headers: { 'X-CodeClient': codeClient } } : undefined,
	);

export const getDemandesComptesByStatus = async (
	statusCode: DemandeStatusType = DemandeStatusEnum.HS,
	codeClient?: string,
) => {
	const statusParam =
		statusCode === DemandeStatusEnum.NON_TRAITEE
			? 'isNull()'
			: encodeURIComponent(statusCode);

	return request.get<unknown, TemplateRequestGet<DemandeCompte>>(
		`/api/ixchange/demandeCompteAllClients?dem_status_code=${statusParam}`,
		codeClient ? { headers: { 'X-CodeClient': codeClient } } : undefined,
	);
};

export const updateDemandeCompte = async (demandeCompte: DemandeCompte) =>
	request.put<Partial<DemandeCompte>, DemandeCompte>(
		`/api/ixchange/demandeCompte/${demandeCompte.identifiant}`,
		demandeCompte,
	);

export const deleteDemandeCompte = async (id: number) =>
	request.delete(`/api/ixchange/demandeCompte/${id}`);

export const updateDemandeCompteStatus = async (
	id: number,
	statut: string,
	messagePrive: string,
	messagePublic: string,
) =>
	request.put<
		{
			Abandon: boolean;
			RazStatus: boolean;
			Traité: boolean;
			messagePrive: string;
			messagePublic: string;
		},
		{ status: { status: string } }
	>(`/api/ixchange/demandeCompteStatus/${id}`, {
		Abandon: statut === DemandeStatusEnum.ABANDON,
		RazStatus: statut === 'RazStatus',
		Traité: statut === DemandeStatusEnum.TRAITEE,
		messagePrive,
		messagePublic,
	});

export const postDemandeCompte = async (
	xmlFile: File,
	certificatFile: File,
) => {
	const formData = new FormData();
	formData.append('xmlFile', xmlFile);
	formData.append('certificatFile', certificatFile);

	return request.post<Partial<FormData>, PostPastellUserResult>(
		`/api/ixchange/pastell/newDemandeCompteFromXml/${xmlFile.name}`,
		formData,
	);
};

export const replaceCertificat = async (id: number, certif: File) => {
	const formData = new FormData();
	formData.append('document', certif);
	return request.post<
		FormData,
		{
			status: string;
			path: string;
			idDemandeCompte: string;
		}
	>(`/api/ixchange/uploadCertificatFromDemandeCompte/${id}`, formData);
};
